"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    apolloUri: process.env.REACT_APP_APOLLO_URI,
    errorApiEndpoint: process.env.REACT_APP_ERROR_API_ENDPOINT,
    winston: {
        logLevel: process.env.REACT_APP_WINSTON_LOG_LEVEL,
    },
};
